import {Component, OnInit} from '@angular/core';

import {UserblockService} from './userblock.service';
import { CustomOAuthService } from 'src/service/custom-oauth-service';

@Component({
  selector: 'app-userblock',
  templateUrl: './userblock.component.html',
  styleUrls: ['./userblock.component.scss']
})
export class UserblockConsultorComponent implements OnInit {
  usuario: any;
  user: any;
  public nome: string;

  constructor(public userblockService: UserblockService, private oauthService: CustomOAuthService) {

    this.usuario = this.givenName();

    this.user = {
      picture: 'assets/img/user/02.png'
    };

  }

  ngOnInit() {
  }

  givenName() {
    var claims = this.oauthService.getIdentityClaims();
    if (!claims) return null;
    return claims['principal'];
  }

  userBlockIsVisible() {
    return this.userblockService.getVisibility();
  }

}
